import color from "../resource/color";

export type CreditLimitStatus = "WAITING" | "FREEBIES_NOT_MIX" | "DISCOUNT_MIX";

export const CreditLimitStatusLabel = {
  WAITING: "รออนุมัติ",
  APPROVED: "อนุมัติแล้ว",
  REJECTED: "ไม่อนุมัติ",
};

export const CreditLimitStatusColor = {
  WAITING: color.warning,
  APPROVED: color.success,
  REJECTED: color.error,
};

//card summary credit detail
interface ShopDetailField {
  key: string;
  label: string;
  labelEn?: string;
  unit?: string;
  format?: "currency" | "percentage" | "default";
  subLabel?: string;
}

// creditV2
export const shopDetailFields: ShopDetailField[] = [
  {
    key: "creditLimit",
    label: "วงเงินที่ได้รับ (Primary Credit)",
    labelEn: "",
    format: "currency",
  },
  {
    key: "overCredit",
    label: "วงเงินชั่วคราว (Temporary Credit)",
    labelEn: "",
    unit: "คำขอ",
    format: "currency",
  },
  {
    key: "creditLimitTotal",
    label: "วงเงินรวมทั้งหมด (Total Credit Limit)",
    labelEn: "",
    format: "currency",
  },
  {
    key: "arOverCredit",
    label: "วงเงินเกินสะสม  (Over Credit)",
    labelEn: "",
    unit: "คำขอ",
    format: "currency",
  },
  {
    key: "pending",
    label: "คำสั่งซื้อที่รอดำเนินการ",
    labelEn: "(Order Pending)",
    format: "currency",
  },
  {
    key: "creditLimitBalance",
    label: "วงเงินคงเหลือ (Credit Limit Balance)",
    labelEn: "",
    format: "currency",
    subLabel: "* ยอดชำระเงินเกินจะถูกเพิ่มในวงเงินคงเหลือ *",
  },
  {
    key: "creditBalance",
    label: "วงเงินคงเหลือที่ร้านเห็น",
    labelEn: "(Credit Limit Balance for Shop App)",
    format: "currency",
    subLabel: "(วงเงินคงเหลือ + เช็คลงวันที่ล่วงหน้า)",
  },
  { key: "arBalance", label: "ลูกหนี้การค้า (A/R Balance)", labelEn: "", format: "currency" },
  { key: "pdcCollect", label: "เช็คลงวันที่ล่วงหน้า (PDC)", labelEn: "", format: "currency" },
  { key: "outstanding", label: "ยอดหนี้ค้างชำระ (Outstanding)", labelEn: "", format: "currency" },
];
